import { Divider, HStack, Text, VStack } from "@chakra-ui/react";
import { currency } from "@src/utils/formatters";
import { observer } from "mobx-react-lite";
import { Fragment } from "react";
import BudgetItem from "./BudgetItem";
import type { BudgetItemStore } from "./BudgetItemStore";

interface BudgetItemsGroupProps {
  brandName: string;
  expenseItems: [string, BudgetItemStore][];
}

const BudgetItemsGroup = ({
  expenseItems,
  brandName,
}: BudgetItemsGroupProps) => {
  const totalAmount = expenseItems.reduce(
    (acc, [, { form }]) =>
      acc + form.$.amount_in_currency.value.denominatedValue,
    0,
  );

  return (
    <VStack align="start" display="flex">
      <HStack pos="sticky" left="0">
        <Text mr="4" color="gray.500">
          {brandName}
        </Text>
        <Text mr="4" ml="0.5" color="gray.500">
          {currency.formatByWorkspace(totalAmount)}
        </Text>
      </HStack>
      {expenseItems.map(([key, item], index) => (
        <Fragment key={key}>
          <BudgetItem id={key} itemStore={item} />
          {index < expenseItems.length - 1 && <Divider my="3" />}
        </Fragment>
      ))}
    </VStack>
  );
};

export default observer(BudgetItemsGroup);
